/**
 * The Composer's keyboard focus ring, for controls that are not a `Button`.
 *
 * `Button`'s cva already carries this exact ring, and so do `SelectTrigger`,
 * `Switch` and the chip triggers. The Composer also ships several raw
 * `<button>` and `<a>` elements, namely send, stop, the context meter and the
 * pull request badge. Those inherit nothing, so before this constant existed
 * they were the controls a keyboard user could reach and not see. One string rather
 * than four hand-typed copies, because a ring that differs by a token on one
 * control is the same defect in a quieter form.
 */
export const COMPOSER_FOCUS_RING_CLASS =
  "outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background";
